export const container ="flex justify-center items-center  w-full min-h-screen"
export const formContainer ="w-full md:w-3/5 mx-4"
export const nameDiv ="grid grid-cols-1 md:grid-cols-2 gap-4"
export const buttonDiv ='flex justify-center'
export const button ='bg-custom-button-green'
export const progessBarContainer ="w-full bg-gray-200 h-2 rounded"
export const progessBar ="bg-custom-button-green h-2 rounded"
export const passwordDescription="text-sm font-normal text-green-800"
export const passwordConditions ="flex items-center mt-2 text-sm"
export const link ='text-sm font-bold'
export const customLink ='text-green-700'




